export const defaultPrimaryColor = '#10275B';
export const defaultSecondaryColor = '#849299';
export const defaultAccentColor = '#075291';
